/*
 * Converts between shipstation-ui's weight unit of measure and ui-component's weight unit of measure.
 */

import { WeightInputUnit } from 'ui-components/components/weight-input/units';
import { WeightUnit } from '../../../enums/weight-unit';

export const convertToWeightUnitEnum = (weightInputUnit) => {
  if ([WeightInputUnit.grams, WeightInputUnit.gram].includes(weightInputUnit.toLowerCase())) {
    return WeightUnit.Grams;
  }

  return WeightUnit.Ounces;
};

export const convertFromWeightUnitEnum = (weightUnitEnum) => {
  if ([WeightUnit.Grams, WeightUnit.Gram].includes(WeightUnit[weightUnitEnum])) {
    return WeightInputUnit.grams;
  }

  return WeightInputUnit.ounces;
};
